export const GET_PROPERTY_REQUEST = "GET_PROPERTY_REQUEST";
export const GET_PROPERTY_SUCCESS = "GET_PROPERTY_SUCCESS";
export const GET_PROPERTY_FAILURE = "GET_PROPERTY_FAILURE";

export const PATCH_PROPERTY_REQUEST = "PATCH_PROPERTY_REQUEST";
export const PATCH_PROPERTY_SUCCESS = "PATCH_PROPERTY_SUCCESS";
export const PATCH_PROPERTY_FAILURE = "PATCH_PROPERTY_FAILURE";
